import { createSelector } from '@ngrx/store';
import { getAdditionalServicesState } from './state.selector';

export const getTermsConditionsState = createSelector(
  getAdditionalServicesState,
  (state) => state.terms
);

export const isTermsConditionsSelected = createSelector(
  getTermsConditionsState,
  (state) => !!state.data
);
